import React, { useCallback, useEffect, useState } from "react";
import api from "./api";
import StartDecisionReview from "./reviews/StartDecisionReview";
import DecisionReviewDetail from "./reviews/DecisionReviewDetail";
import { abbreviateSha } from "./reviews/reviewDisplay";
import "./app/shell.css";

export default function DecisionReviewPanel({ repo, mutateAllowed = false }) {
  const [current, setCurrent] = useState([]);
  const [history, setHistory] = useState([]);
  const [active, setActive] = useState(null);
  const [alreadyReviewed, setAlreadyReviewed] = useState(false);

  const load = useCallback(async () => {
    if (!repo?._id) return;
    try {
      const response = await api.get(`/repos/${repo._id}/decision-reviews`);
      setCurrent(response?.data?.current || []);
      setHistory(response?.data?.history || []);
    } catch {
      setCurrent([]);
      setHistory([]);
    }
  }, [repo?._id]);

  useEffect(() => {
    load();
  }, [load]);

  const review = active || current[0] || null;

  return (
    <div className="rr-decision">
      <StartDecisionReview
        embedded
        repositories={repo?._id ? [repo] : []}
        repositoryId={repo?._id || ""}
        mutateAllowed={mutateAllowed}
        onStarted={(next, existing) => {
          setActive(next || null);
          setAlreadyReviewed(Boolean(existing));
          load();
        }}
      />
      {review ? (
        <DecisionReviewDetail review={review} mutateAllowed={mutateAllowed} alreadyReviewed={alreadyReviewed} embedded />
      ) : null}
      {history.length > 0 ? (
        <section data-testid="decision-review-history">
          <h2>Earlier pull request reviews</h2>
          <ul>
            {history.map((item) => (
              <li key={item.id}>
                Stale #{item.pullNumber} · {abbreviateSha(item.headSha)}
              </li>
            ))}
          </ul>
        </section>
      ) : null}
    </div>
  );
}
